import { render, staticRenderFns } from "./confirmjanvideoflow.vue?vue&type=template&id=fbebebb0&lang=pug&"
import script from "./confirmjanvideoflow.vue?vue&type=script&lang=js&"
export * from "./confirmjanvideoflow.vue?vue&type=script&lang=js&"
import style0 from "./confirmjanvideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports